import { render } from "./AppDisclosurePanel.vue?vue&type=template&id=7b6a8bb1&ts=true"
import script from "./AppDisclosurePanel.vue?vue&type=script&lang=ts"
export * from "./AppDisclosurePanel.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__